import Vue from 'vue'
import Icon from '@/components/elements/Icon';

import 'remixicon/fonts/remixicon.css'
Vue.component('icon', Icon)
